import * as React from 'react';
import {
  Link,
  withRouter,
} from 'react-router-dom';

import { SignUpLink } from './SignUp';
import { PasswordForgetLink } from './PasswordForget';
import * as firebase from 'firebase/app'
import { auth, db } from '../../firebase';
import * as routes from '../../constants/routes';
import { FormGroup, FormControl, ControlLabel, HelpBlock, Button, Alert, Fade } from 'react-bootstrap';
import '../../sass/Authentication.css';
import Logo from '../Logo';
import LoadingOverlay from '../LoadingOverlay';
import Spinner from 'react-spinkit';
import { FacebookLoginButton, GoogleLoginButton, createButton } from "react-social-login-buttons";

const SignInPage = ({ history }) =>
  <div id='signInModal' className='authModal'>
    <Logo/>
    <LoadingOverlay />
    <div>
      <h2>Sign In</h2>
      <SignInForm history={history} />
      <PasswordForgetLink />
      <SignUpLink />
    </div>
  </div>

const updateByPropertyName = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
  loggingIn: false
};

class SignInForm extends React.Component<any,any> {
  constructor(props) {
    super(props);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    console.log("Logging in");
    this.setState({loggingIn: true})
    // this.props.toggleLoggingIn(true);

    const {
      email,
      password,
    } = this.state;

    const {
      history,
    } = this.props;

    auth.doSignInWithEmailAndPassword(email, password)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.HOME);
        console.log("Logged in: ", this.state.loggingIn);
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
        this.setState({loggingIn: false});
        // this.props.toggleLoggingIn(false);
      });

    event.preventDefault();
  }

  private handleEmailChange(e:any) {
    this.setState(updateByPropertyName('email', e.target.value));
  }

  private handlePasswordChange(e:any) {
    this.setState(updateByPropertyName('password', e.target.value));
  }

  private handleGoogleAuth(e:any) {
    let provider = new firebase.auth.GoogleAuthProvider();
    this.handlePopupAuth(provider);
  }

  private handleFacebookAuth(e:any) {
    let provider = new firebase.auth.FacebookAuthProvider();
    this.handlePopupAuth(provider);
  }

  private handlePopupAuth(provider) {
    this.setState({loggingIn: true})
    const {
      history,
    } = this.props;
    auth.doSignInWithPopup(provider)
      .then((result) => {
        this.setState(() => ({ ...INITIAL_STATE }));
        history.push(routes.HOME);
        // console.log("Logged in: ", this.state.loggingIn, result.user.uid);
        let nameArray:Array<string> = result.user.displayName.split(" ");
        let firstName = nameArray[0];
        let lastName = nameArray[1];
        if (lastName == null) {lastName = ""}
        firebase.database().ref("users").child(result.user.uid).once('value', function(snapshot) {
          console.log('User exists: ', snapshot.exists());
          if (snapshot.exists() == false) {
            db.doCreateUser(result.user.uid, firstName, lastName, result.user.email)
          }
        });
      })
      .catch(error => {
        this.setState(updateByPropertyName('error', error));
        this.setState({loggingIn: false});
        // this.props.toggleLoggingIn(false);
      });
  }

  render() {
    const {
      email,
      password,
      error,
    } = this.state;

    const isInvalid =
      password === '' ||
      email === '';

    // function FieldGroup({ id, label, help, ...props }) {
    //     return (
    //       <FormGroup controlId={id}>
    //         <ControlLabel>{label}</ControlLabel>
    //         <FormControl {...props} />
    //         {help && <HelpBlock>{help}</HelpBlock>}
    //       </FormGroup>
    //     );
    //   }
    return (
      <div>
        {
          this.state.loggingIn ?
          <Spinner name="folding-cube" color="aqua"/> : null
        }
        {
          error && !this.state.loggingIn ?
          <Alert bsStyle="danger">
          {error.message}
          </Alert> : null
        }
        {
          !this.state.loggingIn ?
          <form id='signInForm' onSubmit={this.onSubmit}>
            <div className="socialLoginButtons">
              <div className="socialLogin"><GoogleLoginButton onClick={this.handleGoogleAuth.bind(this)} /></div>
              <div className="socialLogin"><FacebookLoginButton onClick={this.handleFacebookAuth.bind(this)} /></div>
              {/* <div className="socialLogin"><FacebookLoginButton onClick={this.handleFacebookAuth.bind(this)} /></div> */}
            </div>
            <div id="or">OR</div>
            <div id='signInForm'>
              <FormGroup className='signInInput' controlId='formControlsEmail'>
                  <FormControl
                    onChange={this.handleEmailChange}
                    value={email}
                    id="formControlsEmail"
                    type="email"
                    label="Email address"
                    placeholder="Enter email" />
                {/* <HelpBlock>Enter your email address</HelpBlock> */}
              </FormGroup>
              <FormGroup className='signInInput' controlId='formControlsPassword'>
                  <FormControl
                    onChange={this.handlePasswordChange}
                    value={password}
                    id="formControlsPassword"
                    type="password"
                    label="Password"
                    placeholder="Enter password" />
                {/* <HelpBlock>Enter your email address</HelpBlock> */}
              </FormGroup>
            </div>
            <Button disabled={isInvalid || this.state.loggingIn} className="signInBtn mainBtn button-blue" type="submit">Submit</Button>
        </form> : null
        }
      </div>
      // <form onSubmit={this.onSubmit}>
      //   <input
      //     value={email}
      //     onChange={event => this.setState(updateByPropertyName('email', event.target.value))}
      //     type="text"
      //     placeholder="Email Address"
      //   />
      //   <input
      //     value={password}
      //     onChange={event => this.setState(updateByPropertyName('password', event.target.value))}
      //     type="password"
      //     placeholder="Password"
      //   />
      //   <button disabled={isInvalid} type="submit">
      //     Sign In
      //   </button>

      //   { error && <p>{error.message}</p> }
      // </form>
    );
  }
}

const SignInLink = () =>
  <p>
    Already have an account?
    {' '}
    <span className='link'><Link to={routes.SIGN_IN}>Sign In</Link></span>
  </p>

export default withRouter(SignInPage);

export {
  SignInForm,
  SignInLink
};



// WEBPACK FOOTER //
// ./src/components/routes/SignIn.tsx